'use client';

import { useEffect } from 'react';
import { trackCartIdExists } from 'utils';

interface CartIdTrackerProps {
  cartId: string | undefined;
}

/**
 * CartIdTracker - Fires a Jentis cart_id_exists event on mount
 *
 * Rendered inside CartOverviewContent after the cartId is resolved from PSI.
 * Uses useEffect to fire client-side tracking after hydration.
 *
 * Renders nothing — tracking only.
 */
export function CartIdTracker({ cartId }: CartIdTrackerProps) {
  useEffect(() => {
    if (cartId) {
      trackCartIdExists(cartId);
    }
  }, [cartId]);

  return null;
}
